import { tierById } from './catalog';
import { quote } from './pricing';
import type { SponsorAccount, SponsorState } from './types';

const DAY_MS = 86_400_000;
const createId = (prefix: string) => `${prefix}-${globalThis.crypto.randomUUID()}`;
const toIsoString = (time: number) => new Date(time).toISOString();

export function createDemoSponsorState(now = Date.now()): SponsorState {
  const telecom: SponsorAccount = {
    id: 'acc-telecom-c', company: 'Telecom C', email: 'ads@telecomc.com.kh', phone: '012 345 678',
    businessType: 'Telecom', licence: 'MOC-00418822', licencePhoto: 'licence.jpg', status: 'verified', createdAt: toIsoString(now - 40 * DAY_MS),
  };
  const ngo: SponsorAccount = {
    id: 'acc-ngo-d', company: 'Clean Water NGO', email: 'comms@cleanwater.org', phone: '017 222 901',
    businessType: 'NGO', licence: 'MOI-2231', licencePhoto: 'registration.pdf', status: 'registered', createdAt: toIsoString(now - 1 * DAY_MS),
  };
  const q1 = quote(tierById('premium'), 0, 3, 'biz');
  const q2 = quote(tierById('growth'), 0, 1, 'ngo');
  return {
    version: 1,
    currentAccountId: null,
    accounts: [telecom, ngo],
    orders: [
      {
        id: 'ord-telecom-c', no: 'LB-40213', accountId: telecom.id, company: telecom.company, contact: 'Sokha P.', phone: telecom.phone,
        tier: 'premium', stopIndex: 0, periodMonths: 3, months: q1.months, segment: 'biz', method: 'bank',
        list: q1.list, paid: q1.paid, vat: q1.vat, total: q1.total, status: 'live',
        createdAt: toIsoString(now - 35 * DAY_MS), start: toIsoString(now - 30 * DAY_MS), end: toIsoString(now + 60 * DAY_MS),
        link: 'https://telecomc.com.kh/5g', provinces: ['All provinces'],
        ads: [
          { id: createId('ad'), title: '5G is here', type: 'Banner', showsIn: 'All apps', status: 'live', share: 0.5 },
          { id: createId('ad'), title: 'Data for workers', type: 'Feed post', showsIn: 'IDI, Survey', status: 'live', share: 0.3 },
          { id: createId('ad'), title: 'Phone habits survey', type: 'Sponsored survey', showsIn: 'Survey app', status: 'live', share: 0.2 },
        ],
      },
      {
        id: 'ord-ngo-d', no: 'LB-40388', accountId: ngo.id, company: ngo.company, contact: 'Maly K.', phone: ngo.phone,
        tier: 'growth', stopIndex: 0, periodMonths: 1, months: q2.months, segment: 'ngo', method: 'khqr',
        list: q2.list, paid: q2.paid, vat: q2.vat, total: q2.total, status: 'in_review',
        createdAt: toIsoString(now - 1 * DAY_MS), start: toIsoString(now + 1 * DAY_MS), end: toIsoString(now + 31 * DAY_MS),
        link: 'https://cleanwater.org/pledge', provinces: ['Siem Reap', 'Battambang'],
        ads: [{ id: createId('ad'), title: 'Safe water, healthy family', type: 'Banner', showsIn: 'All apps', status: 'checking', share: 1 }],
      },
    ],
    payments: [
      { id: createId('pay'), date: toIsoString(now - 33 * DAY_MS), accountId: telecom.id, orderId: 'ord-telecom-c', item: 'Premium package · 3 months', no: 'LB-40213', amount: q1.total, status: 'paid' },
      { id: createId('pay'), date: toIsoString(now - 1 * DAY_MS), accountId: ngo.id, orderId: 'ord-ngo-d', item: 'Growth package · 1 month', no: 'LB-40388', amount: q2.total, status: 'paid' },
    ],
    extraPoints: {},
    notices: [],
  };
}
